export const Card = ({ color = "#FFD700" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9V8.2C3 7.08 3 6.52 3.218 6.092C3.41 5.715 3.715 5.41 4.092 5.218C4.52 5 5.08 5 6.2 5H17.8C18.92 5 19.48 5 19.907 5.218C20.284 5.41 20.59 5.715 20.782 6.092C21 6.519 21 7.079 21 8.197V9M3 9H21M3 9V15.8C3 16.92 3 17.48 3.218 17.908C3.40974 18.2843 3.71569 18.5903 4.092 18.782C4.519 19 5.079 19 6.197 19H17.803C18.921 19 19.48 19 19.907 18.782C20.284 18.59 20.59 18.284 20.782 17.908C21 17.48 21 16.922 21 15.804V9M6 15H10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Arrow = ({ className, stroke = "#FFD700", onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.5L12 19.5M12 19.5L18 13.875M12 19.5L6 13.875"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Cheveron = ({ className, stroke }) => {
  return (
    <svg
      className={className}
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9L5 5L1 1"
        stroke={stroke}
        strokeOpacity="0.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Bank = ({ className }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="5" fill="#534D26" />
      <path
        d="M18.5 22H16.5V29H18.5V22ZM24.5 22H22.5V29H24.5V22ZM33 31H14V33H33V31ZM30.5 22H28.5V29H30.5V22ZM23.5 15.26L28.71 18H18.29L23.5 15.26ZM23.5 13L14 18V20H33V18L23.5 13Z"
        fill="#FFD700"
      />
    </svg>
  );
};

export const FundCard = ({ color = "#FFD700" }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="5" fill={color} fillOpacity="0.2" />
      <path
        d="M36 17.375V31.625C36 32.2781 35.7652 32.8374 35.2956 33.3029C34.826 33.7684 34.2608 34.0008 33.6 34H14.4C13.74 34 13.1752 33.7676 12.7056 33.3029C12.236 32.8382 12.0008 32.2789 12 31.625V17.375C12 16.7219 12.2352 16.163 12.7056 15.6982C13.176 15.2335 13.7408 15.0008 14.4 15H33.6C34.26 15 34.8252 15.2327 35.2956 15.6982C35.766 16.1637 36.0008 16.7227 36 17.375ZM14.4 19.75H33.6V17.375H14.4V19.75ZM14.4 24.5V31.625H33.6V24.5H14.4Z"
        fill={color}
      />
    </svg>
  );
};

export const Phone = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="5" fill="#534D26" />
      <path
        d="M28.2567 12H19.25C18.0072 12 17 13.0073 17 14.25V33.75C17 34.9928 18.0072 36 19.25 36H28.2567C29.4995 36 30.5067 34.9928 30.5067 33.75V14.25C30.5067 13.0073 29.4995 12 28.2567 12ZM29.0067 33.75C29.0067 34.164 28.6707 34.5 28.2567 34.5H19.25C18.836 34.5 18.5 34.164 18.5 33.75V14.25C18.5 13.836 18.836 13.5 19.25 13.5H28.2567C28.6707 13.5 29.0067 13.836 29.0067 14.25V33.75ZM23.7545 30.7541C22.9276 30.7541 22.2583 31.4242 22.2583 32.25C22.2583 33.0758 22.928 33.7463 23.7545 33.7463C24.5814 33.7463 25.2507 33.0758 25.2507 32.25C25.2507 31.4243 24.5814 30.7541 23.7545 30.7541ZM25.2545 14.25H22.2545C21.8405 14.25 21.5045 14.586 21.5045 15C21.5045 15.414 21.8405 15.75 22.2545 15.75H25.2545C25.6685 15.75 26.0045 15.414 26.0045 15C26.0045 14.586 25.6685 14.25 25.2545 14.25Z"
        fill="#FFD700"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2.5" fill="#FFD700" fillOpacity="0.25" />
      <path
        d="M8 15C8 14.4696 8.21071 13.9609 8.58579 13.5858C8.96086 13.2107 9.46957 13 10 13H14C14.5304 13 15.0391 13.2107 15.4142 13.5858C15.7893 13.9609 16 14.4696 16 15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H9C8.73478 16 8.48043 15.8946 8.29289 15.7071C8.10536 15.5196 8 15.2652 8 15Z"
        stroke="#FFD700"
        strokeLinejoin="round"
      />
      <path
        d="M11.998 11C12.8265 11 13.498 10.3284 13.498 9.5C13.498 8.67157 12.8265 8 11.998 8C11.1696 8 10.498 8.67157 10.498 9.5C10.498 10.3284 11.1696 11 11.998 11Z"
        stroke="#FFD700"
      />
    </svg>
  );
};

export const BankOutlined = ({ bgFill = "#1A1F33", fill = "#0A0D16" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill={bgFill} fillOpacity="0.5" />
      <path
        d="M12.334 14.6665H11.0007V19.3332H12.334V14.6665ZM16.334 14.6665H15.0007V19.3332H16.334V14.6665ZM22.0007 20.6665H9.33398V21.9998H22.0007V20.6665ZM20.334 14.6665H19.0007V19.3332H20.334V14.6665ZM15.6673 10.1732L19.1407 11.9998H12.194L15.6673 10.1732ZM15.6673 8.6665L9.33398 11.9998V13.3332H22.0007V11.9998L15.6673 8.6665Z"
        fill={fill}
      />
    </svg>
  );
};

export const FilledSuccessCheck = () => {
  return (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="80"
        height="80"
        transform="translate(0.5)"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.4993 73.3332C22.0893 73.3332 7.16602 58.4098 7.16602 39.9998C7.16602 21.5898 22.0893 6.6665 40.4993 6.6665C58.9093 6.6665 73.8327 21.5898 73.8327 39.9998C73.8327 58.4098 58.9093 73.3332 40.4993 73.3332ZM36.576 47.1332L27.3593 37.9098L23.8327 41.4365L34.2293 51.8398C34.8544 52.4647 35.7021 52.8158 36.586 52.8158C37.4699 52.8158 38.3176 52.4647 38.9427 51.8398L58.7827 32.0065L55.2427 28.4665L36.576 47.1332Z"
        fill="#91FED1"
        fillOpacity="0.933333"
      />
    </svg>
  );
};

export const Locate = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9996 17.4002C11.3962 17.4003 10.815 17.1732 10.3715 16.764C9.92811 16.3548 9.65508 15.7936 9.60681 15.1922C8.00623 14.6256 6.65727 13.5119 5.79804 12.0474C4.93881 10.583 4.62456 8.86211 4.91076 7.18852C5.19696 5.51492 6.06522 3.99625 7.36226 2.90057C8.6593 1.8049 10.3017 1.20267 11.9996 1.2002C13.8055 1.19993 15.5455 1.8783 16.8747 3.10079C18.2039 4.32327 19.0251 6.0006 19.1756 7.8002C19.1806 7.87825 19.1693 7.9565 19.1425 8.02997C19.1156 8.10343 19.0738 8.17051 19.0196 8.22694C18.9655 8.28336 18.9001 8.32791 18.8278 8.35773C18.7555 8.38756 18.6778 8.40202 18.5996 8.4002C18.4389 8.39617 18.2854 8.33253 18.1689 8.22164C18.0525 8.11075 17.9815 7.96054 17.9696 7.8002C17.8627 6.7392 17.475 5.72585 16.8464 4.86448C16.2178 4.00311 15.3709 3.32484 14.393 2.8995C13.4152 2.47416 12.3416 2.31711 11.2829 2.44453C10.2242 2.57195 9.21852 2.97922 8.3695 3.62443C7.52047 4.26964 6.85874 5.12947 6.45243 6.1154C6.04612 7.10132 5.90991 8.17772 6.05782 9.23378C6.20573 10.2898 6.63242 11.2874 7.29396 12.1238C7.9555 12.9601 8.82799 13.6051 9.82161 13.9922C10.0024 13.6015 10.2849 13.2667 10.6396 13.0228C10.9943 12.7788 11.408 12.6348 11.8375 12.6057C12.267 12.5766 12.6964 12.6636 13.0807 12.8575C13.4651 13.0514 13.7901 13.3451 14.022 13.7078C14.2538 14.0705 14.3838 14.4889 14.3983 14.9191C14.4128 15.3493 14.3114 15.7755 14.1046 16.1531C13.8978 16.5306 13.5933 16.8456 13.223 17.065C12.8526 17.2844 12.4301 17.4002 11.9996 17.4002ZM6.01041 14.4002H6.11961C6.58761 14.8574 7.10721 15.2606 7.67001 15.6002H6.01041C5.33721 15.6002 4.79961 16.1366 4.79961 16.8002C4.79961 18.371 5.54601 19.541 6.80721 20.3438C8.09121 21.1634 9.91761 21.6002 11.9996 21.6002C14.0816 21.6002 15.908 21.1634 17.192 20.3438C18.452 19.5398 19.1996 18.3722 19.1996 16.8002C19.1996 16.4819 19.0732 16.1767 18.8481 15.9517C18.6231 15.7266 18.3179 15.6002 17.9996 15.6002H15.5504C15.6175 15.203 15.6175 14.7974 15.5504 14.4002H17.9996C18.6361 14.4002 19.2466 14.6531 19.6967 15.1031C20.1468 15.5532 20.3996 16.1637 20.3996 16.8002C20.3996 18.8294 19.4 20.3594 17.8376 21.3566C16.2992 22.337 14.2256 22.8002 11.9996 22.8002C9.77361 22.8002 7.70001 22.337 6.16161 21.3566C4.59921 20.3606 3.59961 18.8282 3.59961 16.8002C3.59961 15.4646 4.68321 14.4002 6.01041 14.4002ZM16.7996 8.4002C16.7999 9.21216 16.5941 10.0109 16.2017 10.7217C15.8092 11.4326 15.2429 12.0322 14.5556 12.4646C14.2353 12.1416 13.8566 11.8822 13.4396 11.7002C14.1976 11.3694 14.8186 10.7876 15.1982 10.0528C15.5777 9.31796 15.6926 8.47485 15.5237 7.66523C15.3547 6.85561 14.9121 6.12886 14.2703 5.60719C13.6285 5.08552 12.8267 4.80074 11.9996 4.80074C11.1725 4.80074 10.3707 5.08552 9.72891 5.60719C9.08712 6.12886 8.64452 6.85561 8.47555 7.66523C8.30657 8.47485 8.42152 9.31796 8.80106 10.0528C9.1806 10.7876 9.80159 11.3694 10.5596 11.7002C10.1396 11.8838 9.76161 12.1442 9.44361 12.4646C8.53211 11.8914 7.83982 11.0283 7.47801 10.0142C7.29343 9.49612 7.19926 8.95017 7.19961 8.4002C7.19961 7.12716 7.70532 5.90626 8.6055 5.00608C9.50567 4.10591 10.7266 3.6002 11.9996 3.6002C13.2726 3.6002 14.4935 4.10591 15.3937 5.00608C16.2939 5.90626 16.7996 7.12716 16.7996 8.4002Z"
        fill="#FFD700"
      />
    </svg>
  );
};

export const ProgressStepper = ({
  step2 = "#1A1F33",
  step3 = "#1A1F33",
  step4 = "#1A1F33",
}) => {
  return (
    <svg
      width="370"
      height="23"
      viewBox="0 0 370 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="21.8203"
        y1="10.9099"
        x2="121.436"
        y2="10.9099"
        stroke={step2}
        strokeWidth="4.74359"
      />
      <rect
        x="0.474359"
        y="0.474359"
        width="21.8205"
        height="21.8205"
        rx="10.9103"
        fill="#FFD700"
        stroke="#FFD700"
        strokeWidth="0.948718"
      />
      <line
        x1="132.82"
        y1="10.9099"
        x2="232.436"
        y2="10.9099"
        stroke={step3}
        strokeWidth="4.74359"
      />
      <rect
        x="112.424"
        y="0.474359"
        width="21.8205"
        height="21.8205"
        rx="10.9103"
        fill={step2}
        stroke={step2}
        strokeWidth="0.948718"
      />
      <line
        x1="251.41"
        y1="10.9099"
        x2="351.026"
        y2="10.9099"
        stroke={step4}
        strokeWidth="4.74359"
      />
      <rect
        x="230.064"
        y="0.474359"
        width="21.8205"
        height="21.8205"
        rx="10.9103"
        fill={step3}
        stroke={step3}
        strokeWidth="0.948718"
      />
      <rect
        x="347.23"
        width="22.7692"
        height="22.7692"
        rx="11.3846"
        fill={step4}
      />
    </svg>
  );
};
